/**
 * Index page
 *
 * @author aheshperera
 */

// For IE Support
import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support

/**
 * React Modules
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { LicenseManager } from 'ag-grid-enterprise';
import * as serviceWorker from './serviceWorker';
import './index.css';
import App from './App';
import './polyfill';

/**
 * Render the main content for root element
 */
/* eslint-disable-next-line max-len */
LicenseManager.setLicenseKey('CompanyName=MoreDirect_on_behalf_of_Sysco Corporation,LicensedApplication=Cost Data Management,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=4,LicensedProductionInstancesCount=0,AssetReference=AG-012004,ExpiryDate=22_June_2022_[v2]_MTY1NTg1MjQwMDAwMA==b47f8dc8f1170825ff5d364834873052');
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
